<template>
  <section class="paragraph__sub-paragraphs" v-if="subParagraphs.length">
    <div
      v-for="(sub, index) in subParagraphs"
      :key="index"
      :class="[
        'paragraph__cards',
        { 'paragraph__cards--one-card': subParagraphs.length === 1 },
      ]"
    >
      <div class="card-with-words" v-if="sub && sub.type === 'image'">
        <div class="card-with-words__photo">
          <img
            :src="sub.reference"
            :alt="
              sub.description ? `[打開照片]${sub.description}` : '[打開照片]'
            "
            :title="
              sub.description ? `[打開照片]${sub.description}` : '[打開照片]'
            "
            :aria-describedby="`sub-${parentIndex}-${index}`"
            @click="expandFullPhoto(sub)"
          />
        </div>
        <p
          :id="`sub-${parentIndex}-${index}`"
          class="card-with-words__description"
        >
          {{ sub.description }}
        </p>
      </div>
      <div class="card-with-words" v-else>
        <iframe
          class="card-with-words__video"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          :src="`https://www.youtube.com/embed/${sub.reference}`"
          width="300"
          height="174"
          :title="sub.description ? sub.description : '暫無影片描述'"
        ></iframe>
        <p
          :id="`sub-${parentIndex}-${index}`"
          class="card-with-words__description"
        >
          {{ sub.description }}
        </p>
      </div>
    </div>

    <Lightbox
      :isPhotoExpanded="isPhotoExpanded"
      :isCurrentPhotoLoaded="isCurrentPhotoLoaded"
      :currentPhoto="currentPhoto"
      @update:currentPhotoLoaded="isCurrentPhotoLoaded = $event"
      @update:photoExpanded="isPhotoExpanded = $event"
      @update:currentPhoto="currentPhoto = $event"
    />

    <slot></slot>
  </section>
</template>

<script>
import Lightbox from '@/components/Lightbox';

export default {
  name: 'ArticleSubParagraphs',
  props: {
    parentIndex: {
      type: Number,
      default: 0,
    },
    subParagraphs: {
      type: Array,
      default: () => [],
    },
    category: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      subs: [
        { name: '拜殿青斗石龍柱', title: '拜殿青斗石龍柱', artwork_id: 132 },
        { name: '三川殿龍虎壁', title: '三川殿龍虎壁', artwork_id: 131 },
      ],
      isPhotoExpanded: false,
      currentPhoto: {},
      isCurrentPhotoLoaded: null,
    };
  },
  computed: {
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
  },
  methods: {
    expandFullPhoto(photo) {
      // 打開燈箱
      this.isPhotoExpanded = true;

      // 儲存必要資訊
      this.currentPhoto.image_url = photo.reference;
      this.currentPhoto.description = photo.description;
    },
  },
  components: {
    Lightbox,
  },
};
</script>

<style lang="scss" scoped>
.paragraph {
  &__sub-paragraphs {
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    align-items: flex-start;
    width: 100%;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: transparent;
    }
  }

  &__cards {
    /* flex: 0 0 auto; */
    width: 100%;
    margin-bottom: 10px;

    @include for-tablet {
      width: 45%;
    }

    &--one-card {
      width: 100%;
    }
  }

  &__cards + &__cards {
    margin-top: 10px;
    @include for-tablet {
      margin-top: 0px;
      margin-bottom: 20px;
    }
  }
}

.card-with-words {
  &__photo {
    font-size: 0;
    > img {
      width: 100%;
      object-fit: cover;
      object-position: top;
      cursor: pointer;
    }
  }

  &__video {
    width: 100%;
    padding: 8px 0;
    background: $color-video-bg;
  }

  &__description {
    font-size: 1rem;
    line-height: 1.5;
    margin-top: 10px;
    margin-bottom: 0;
    text-align: left;
    color: $color-light-paragraph;
  }
}
</style>
